import React, { forwardRef, useRef } from "react";
import { SearchBox } from "react-instantsearch";
import { useDispatch, useSelector } from "react-redux";
import { overlayActions } from "../../store/redux/store";
import { ReactComponent as CloseIcon } from "./../../assets/icons/close.svg";
import { ReactComponent as Logo } from "./../../assets/icons/logo.svg";
import { headerAnimation } from "./header-animations";
import "./SearchHeader.scss";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const SearchHeader = forwardRef((props, ref) => {
    const { CHARACTERS_TO_TRIGGER, DEBOUNCE_TIME_MS } = useSelector(
        (state) => state.config,
    );

    const dispatch = useDispatch();
    const toggleSearchOverlay = () => {
        dispatch(overlayActions.toggleSearchOverlay());
    };

    let debouncerID = undefined;
    let debounceDelay = DEBOUNCE_TIME_MS;

    const searchDebouncer = (query, search) => {
        if (debouncerID) {
            clearTimeout(debouncerID);
        }

        if (query.length >= CHARACTERS_TO_TRIGGER || query.length === 0) {
            debouncerID = setTimeout(() => search(query), debounceDelay);
        }
    };

    const timeline = useRef(gsap.timeline({}));

    useGSAP(
        () => {
            const tl = timeline.current;
            tl.add(headerAnimation(), 0.1);
        },
        { dependencies: [ref], scope: ref },
        [ref],
    );

    return (
        <div className="search-header" ref={ref}>
            <div className="search-header__logo">
                <a
                    href="/"
                    title="Inwerk - zur Startseite wechseln"
                    target="_self"
                >
                    <Logo />
                </a>
            </div>
            <div
                className="search-header__close-button"
                onClick={toggleSearchOverlay}
            >
                Suche schließen
                <CloseIcon />
            </div>
            <SearchBox
                className="search-header__search-box"
                autoFocus={true}
                queryHook={searchDebouncer}
                placeholder={"Was suchen Sie heute für Ihr Büro?"}
            />
        </div>
    );
});

export default SearchHeader;
